const sortDrop = (origArr, dragIndex, dropIndex) => {
  const arr = [...origArr];
  let updated = false;
  const updateSorting = (index, sorting) => {
    if (arr[index].sorting !== sorting) {
      arr[index] = { ...arr[index], sorting, updated: true };
      updated = true;
    }
  };
  // At this point, the sorting must match the order in the array,
  // so we might just as well reset it. This should not be necessary,
  // but it might fix issues stemming from the flawed `handleZutatChange`.
  // Most notably, the order might be already wrong in the database,
  // and here we reset it if needed.
  for (let i = 0; i < arr.length; i++) {
    updateSorting(i, i);
  }
  if (dragIndex !== dropIndex) {
    let lastSorting = arr[dropIndex].sorting;
    // Do the actual move
    if (dragIndex < dropIndex) {
      // Moving forward
      for (let i = dropIndex; i > dragIndex; i--) {
        updateSorting(i, arr[i - 1].sorting);
      }
    } else if (dragIndex > dropIndex) {
      // Moving backward
      for (let i = dropIndex; i < dragIndex; i++) {
        updateSorting(i, arr[i + 1].sorting);
      }
    }
    updateSorting(dragIndex, lastSorting);
    arr.sort((a, b) => a.sorting - b.sorting);
  }
  return updated ? arr : origArr;
};

export default sortDrop;
